<script setup>
import { useToast } from '@/composables/useToast'
import { XIcon, AlertCircle, CheckCircle, Info, AlertTriangle } from 'lucide-vue-next'

const { toasts, removeToast } = useToast()

const icons = {
  error: AlertCircle,
  success: CheckCircle,
  info: Info,
  warning: AlertTriangle,
}

const colors = {
  error: 'bg-red-50 border-red-200 text-red-800',
  success: 'bg-green-50 border-green-200 text-green-800',
  info: 'bg-blue-50 border-blue-200 text-blue-800',
  warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
}

const iconColors = {
  error: 'text-red-500',
  success: 'text-green-500',
  info: 'text-blue-500',
  warning: 'text-yellow-500',
}
</script>

<template>
  <div class="fixed bottom-6 right-6 z-[99999] flex flex-col gap-2 max-w-sm">
    <TransitionGroup name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        :class="[
          'flex items-start gap-3 px-4 py-3 rounded-lg border shadow-lg',
          colors[toast.type]
        ]"
      >
        <component
          :is="icons[toast.type]"
          :class="['size-5 flex-shrink-0 mt-0.5', iconColors[toast.type]]"
        />
        <p class="text-sm flex-1">{{ toast.message }}</p>
        <button
          type="button"
          class="flex-shrink-0 opacity-60 hover:opacity-100 transition-opacity"
          @click="removeToast(toast.id)"
        >
          <XIcon class="size-4" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.toast-move {
  transition: transform 0.3s ease;
}
</style>
